<div class="card shadow-sm mb-5">
  <div class="card-header text-white">
    <h3 class="mb-0"><i class="fa fa-money-check-alt"></i>Agregar Favorito</h3>
  </div>

  <div class="card-body">
    <div class="col-md-6 form-group mb-4">
        <label class="form-label fw-semibold">Tipo de Favorito</label>
        <select class="form-select" [(ngModel)]="favoriteType">
        <option [ngValue]="null" disabled>Seleccione una tipo de favorito</option>
        <option [ngValue]="'BAM'">BAM</option>
        <option [ngValue]="'ACH'">ACH</option>
        </select>
    </div>
    <div class="row" *ngIf="favoriteType == 'BAM'">
        <div class="col-sm form-group  mb-4">
            <label for="transferType" class="form-label fw-semibold">Tipo de Cuenta</label>
            <select class="form-select" [(ngModel)]="transferType">
            <option [ngValue]="0">Cuenta bancaria propia</option>
            <option [ngValue]="1">Cuenta bancaria a terceros</option>
            </select>
        </div>

        <div class="col-sm form-group mb-4" *ngIf="transferType == 0">
            <label for="bankAccountDebit" class="form-label fw-semibold">Cuenta Bancaria Propia</label>
            <select class="form-select" [(ngModel)]="accountBankNumber">
            <option *ngFor="let account of filterAccounts" [ngValue]="account.accountNumber">
                {{ account.alias }} - {{ account.accountNumber }}
            </option>
            </select>
        </div>

        <!-- Cuentas a terceros -->
        <div class="col-12  mb-4" *ngIf="transferType == 1">
            <div class="mb-3">
            <label class="form-label fw-semibold">Cliente</label>
            <div class="input-group input-group-sm">
                <app-input-autocomplete
                [ruleToDisabled]="clients.length == 0"
                [allBorderRadius]="true"
                [inputs]="client"
                [placeholder]="'Ingresa el NIT o nombre del cliente'"
                [filterElements]="client.filterElements"
                [typeElements]="'client'"
                (inputMethod)="writeClient()"
                (changeStatus)="selectClient($event.filterElement)"
                [custom]="true">
                <ng-template #itemsTemplate let-filter>
                    <div items>
                    <h6 class="text-info mb-0">{{filter.name}}</h6>
                    <small class="text-muted">NIT: <b>{{filter.nit}}</b></small>
                    </div>
                </ng-template>
                </app-input-autocomplete>
            </div>
            </div>

            <!-- Cliente seleccionado -->
            <div *ngIf="clientSelected" class="card border-0 shadow-sm p-3 mb-3 bg-light">
            <div><strong>Nombre:</strong> {{ clientSelected.name }}</div>
            <div><strong>NIT:</strong> {{ clientSelected.nit }}</div>
            <div><strong>Código:</strong> {{ clientSelected.code }}</div>
            </div>

            <!-- Cuentas del cliente -->
            <div class="row">
                <div class="form-group col-sm-8">
                    <label for="thirdPartyAccount" class="form-label fw-semibold">Cuenta del cliente</label>
                    <select class="form-select" [(ngModel)]="selectedThirdPartyAccount">
                        <option *ngFor="let acc of vendorAccounts" [ngValue]="acc.accountNumber">
                        {{ acc.accountNumber }} - {{ getBankName(acc.idBank) }} - {{ getBankAccountTypeName(acc.typeBank) }}
                        </option>
                    </select>
                </div>
    
                <div class="form-group col-sm-4">
                    <label for="thirdPartyAccount" class="form-label fw-semibold">Moneda</label>
                    <select class="form-select" [(ngModel)]="currency">
                        <option [ngValue]="0">GTQ</option>
                        <option [ngValue]="1">USD</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="col-12 mb-4">
            <div class="text-center mt-4">
                <button class="btn btn-success btn-lg px-5" (click)="addFavorite()" [disabled]="loading || !isValidFields">
                    <ng-container *ngIf="loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"></span>
                    </ng-container>
                    <i class="fa fa-plus-circle me-2" *ngIf="!loading"></i> Agregar Favorito
                </button>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="favoriteType == 'ACH'">
        <div class="col-sm form-group mb-4">
            <label for="transferType" class="form-label fw-semibold">Tipo de Producto</label>
            <select class="form-select" [(ngModel)]="productType">
                <option [ngValue]="null" disabled>Seleccione una tipo de Producto</option>
            <option [ngValue]="'LOAN'">Pago Prestamos</option>
            <option [ngValue]="'CREDIT_CARD'">Pago Tarjeta de Credito</option>
            </select>
        </div>

        <div class="col-sm-6 mb-4">
          <label for="productNumber" class="form-label">Número</label>
          <input type="text"
                id="productNumber"
                class="form-control"
                [(ngModel)]="productNumber"
                placeholder="Numero de Prestamo o Tarjeta" />
        </div>

        <div class="form-group col-sm-6 mb-4">
                    <label for="thirdPartyAccount" class="form-label fw-semibold">Banco</label>
                    <select class="form-select" [(ngModel)]="bankId">
                        <option *ngFor="let bank of accountOptions.erpBanks" [ngValue]="bank.id">
                        {{ bank.name }}
                        </option>
                    </select>
                </div>

        <div class="form-group col-sm-6 mb-4">
            <label for="thirdPartyAccount" class="form-label fw-semibold">Moneda</label>
            <select class="form-select" [(ngModel)]="currency">
                <option [ngValue]="0">GTQ</option>
                <option [ngValue]="1">USD</option>
            </select>
        </div>

        <div class="col-sm-6 mb-4">
          <label for="alias" class="form-label">Alias del Favorito</label>
          <input type="text"
                id="alias"
                class="form-control"
                [(ngModel)]="alias"
                placeholder="Alias del Favorito" />
        </div>

        <div class="col-sm-6 mb-4">
          <label for="email" class="form-label">Correo</label>
          <input type="email"
                id="email"
                class="form-control"
                [(ngModel)]="email"
                placeholder="ejemplo@email.com" />
        </div>

        <div class="col-12 mb-4">
            <div class="text-center mt-4">
                <button class="btn btn-success btn-lg px-5" (click)="addFavorite()" [disabled]="loading || !isValidFields">
                    <ng-container *ngIf="loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"></span>
                    </ng-container>
                    <i class="fa fa-plus-circle me-2" *ngIf="!loading"></i> Agregar Favorito
                </button>
            </div>
        </div>
    </div>
  </div>
</div>